<template>
  <div>
    <b-form-select :options="options" v-model="compValue" :disabled="readonly">
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: "CargoExpensePermissionsDropdown",
  props: {
    value: Number,
    readonly: Boolean,
  },
  data() {
    return {
      options: [
        { value: "0", text: "Não possui acesso" },
        { value: "1", text: "Visualiza e edita" },
        { value: "2", text: "Apenas visualização" },
      ],
    };
  },
  computed: {
    compValue: {
      get: function () {
        if (this.options) {
          return this.value;
        }
        return null;
      },
      set: function (newValue) {
        this.$emit("update:value", parseInt(newValue));
      },
    }
  }
};
</script>
